import React from 'react';

import { FieldWrap, FieldMessages, FieldLabel, FieldError } from '../common';
import { FieldInput } from './Input.styles';
import FieldRequiredLabel from '@components/Form/CountrySelect/FieldRequiredLabel';

const Input = ({
  id,
  field,
  name,
  label,
  touched,
  register,
  errors,
  required,
  dark = false,
  ...rest
}) => (
  <FieldWrap>
    <FieldMessages>
      <FieldLabel htmlFor={id} dark={!!dark}>
        {label}
        {required && <FieldRequiredLabel />}
      </FieldLabel>
      {errors && errors[field.name] && (
        <FieldError>{touched && errors[field.name]}</FieldError>
      )}
    </FieldMessages>
    <FieldInput
      id={id}
      name={name}
      ref={register}
      {...field}
      error={!!(errors && touched && errors[field.name])}
      dark={!!dark}
      {...rest}
    />
  </FieldWrap>
);

export default Input;
